module.exports = __webpack_public_path__ + "img/25-r.6af26088.png";